import { useTranslation } from 'react-i18next';
import NumberField from '@/components/fields/NumberField';

const WeightInnerForm = () => {
    const { t } = useTranslation('performanceResult');

    return (
        <div className="sm:col-span-2">
            <NumberField
                name="weightKg"
                label={t('weight.form.weightKg')}
                min={0}
                precision={1}
                suffixElement={t('weight.form.weightKgSuffix')}
            />
        </div>
    );
};

export default WeightInnerForm;
